import React, {useContext, useState} from 'react';
import {Container, Form, Card, Button, Spinner} from "react-bootstrap";
import {NavLink, useLocation, useNavigate} from "react-router-dom";
import {LOGIN_ROUTE, REGISTRATION_ROUTE, SHOP_ROUTE} from "../utils/consts";
import {login, registration, fetchCsrfToken} from "../http/userAPI";
import {observer} from "mobx-react-lite";
import {Context} from "../index";
import { useToast } from '../contexts/ToastContext';
import '../styles/Auth.css';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';

const Auth = observer(() => {
    const {user} = useContext(Context)
    const { showToast } = useToast();
    const location = useLocation()
    const navigate = useNavigate()
    const isLogin = location.pathname === LOGIN_ROUTE
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [name, setName] = useState('')
    const [consentPersonalData, setConsentPersonalData] = useState(true);
    const [consentMarketing, setConsentMarketing] = useState(true);
    const [loading, setLoading] = useState(false);

    const click = async () => {
        if (loading) return;
        setLoading(true);
        try {
            if (isLogin) {
                const data = await login(email, password);
                await fetchCsrfToken();
                localStorage.setItem('token', data.token);
                user.setUser(data.user);
                user.setIsAuth(true);
                navigate(SHOP_ROUTE);
            } else {
                await registration(email, password, name, consentPersonalData, consentMarketing);
                await fetchCsrfToken();
                await user.refreshUser();
                user.setIsAuth(true);
                showToast('Пожалуйста, проверьте вашу почту для подтверждения email', 'info');
                navigate('/verify-email');
            }
        } catch (e) {
            showToast(e.response?.data?.message || 'Произошла ошибка', 'error');
        } finally {
            setLoading(false);
        }
    }

    return (
        <Container
            className="d-flex justify-content-center align-items-center auth-container"
            style={{minHeight: '100vh'}}
        >
            <Card className="p-4 auth-card">
                <h2 className="m-auto mb-4">{isLogin ? 'Авторизация' : 'Регистрация'}</h2>
                <Form className="d-flex flex-column gap-3">
                    {!isLogin &&
                        <Form.Control
                            placeholder="Введите ваше имя"
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                    }
                    <Form.Control
                        placeholder="Введите ваш email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <Form.Control
                        placeholder="Введите ваш пароль"
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                    />
                    {!isLogin && (
                        <>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="consentPersonalData"
                                    checked={consentPersonalData}
                                    onChange={() => setConsentPersonalData(v => !v)}
                                    required
                                />
                                <label className="form-check-label" htmlFor="consentPersonalData">
                                    Я соглашаюсь на обработку моих персональных данных (ФИО, mail) для оформления заказа, а также для получения информации о статусе покупки. С <a href="/privacy" target="_blank" rel="noopener noreferrer">Политикой конфиденциальности</a> ознакомлен(а).
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="consentMarketing"
                                    checked={consentMarketing}
                                    onChange={() => setConsentMarketing(v => !v)}
                                />
                                <label className="form-check-label" htmlFor="consentMarketing">
                                    Согласен(а) получать информацию о новинках и акциях на указанные контакты.
                                </label>
                            </div>
                        </>
                    )}
                    <Button
                        variant="outline-success"
                        onClick={click}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                {isLogin ? 'Вход...' : 'Регистрация...'}
                            </>
                        ) : (
                            (isLogin ? 'Войти' : 'Зарегистрироваться')
                        )}
                    </Button>
                    {isLogin ?
                        <>
                        <div className="mt-2 text-center">
                            Нет аккаунта? <NavLink to={REGISTRATION_ROUTE}>Зарегистрируйся!</NavLink>
                        </div>
                            <div className="mt-2 text-center">
                                <NavLink to="/forgot-password">Забыли пароль?</NavLink>
                            </div>
                            <div className="mt-2 text-center">
                                <NavLink to="/verify-email">Верифицировать аккаунт</NavLink>
                            </div>
                        </>
                        :
                        <div className="mt-2 text-center">
                            Есть аккаунт? <NavLink to={LOGIN_ROUTE}>Войдите!</NavLink>
                        </div>
                    }
                </Form>
            </Card>
        </Container>
    );
});

export default Auth;